<template>
  <section id="about-us">
    <div class="container">
      <div class="row justify-content-center text-center mb-5">
        <div class="col-xl-12 col-lg-9">
          <h2 class="display-4 mx-xl-6">About us</h2>
          <p
            class="lead"
          >We are a small group of data science makers on a mission to build innovative products.</p>
        </div>
      </div>
      <div class="row justify-content-center text-center mb-3">
        <div class="col-xl-2 col-lg-4 col-md-6">
          <div class="align-items-center">
            <img
              src="../assets/img/avatars/felix.jpg"
              alt="Félix MIKAELIAN"
              class="avatar avatar-xlg mb-3"
            >
            <h6 class="mb-0">Félix MIKAELIAN</h6>
            <a href="https://www.linkedin.com/in/fmikaelian/" class="nav-link">
              <svg class="icon" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <title>LinkedIn icon</title>
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                ></path>
              </svg>
            </a>
          </div>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-3">
          <div class="align-items-center">
            <img
              src="../assets/img/avatars/andre.jpg"
              alt="André FARIAS"
              class="avatar avatar-xlg mb-3"
            >
            <h6 class="mb-0">André FARIAS</h6>
            <a href="https://www.linkedin.com/in/andremfarias/" class="nav-link">
              <svg class="icon" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <title>LinkedIn icon</title>
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                ></path>
              </svg>
            </a>
          </div>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6">
          <div class="align-items-center">
            <img
              src="../assets/img/avatars/matyas.png"
              alt="Matyas AMROUCHE"
              class="avatar avatar-xlg mb-3"
            >
            <h6 class="mb-0">Matyas AMROUCHE</h6>
            <a href="https://www.linkedin.com/in/matyas-amrouche-6a1874106/" class="nav-link">
              <svg class="icon" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <title>LinkedIn icon</title>
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                ></path>
              </svg>
            </a>
          </div>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6">
          <div class="align-items-center">
            <img
              src="../assets/img/avatars/theo.png"
              alt="Théo NAZON"
              class="avatar avatar-xlg mb-3"
            >
            <h6 class="mb-0">Théo NAZON</h6>
            <a href="https://www.linkedin.com/in/theo-nazon/" class="nav-link">
              <svg class="icon" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <title>LinkedIn icon</title>
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                ></path>
              </svg>
            </a>
          </div>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6">
          <div class="align-items-center">
            <img
              src="../assets/img/avatars/olivier.png"
              alt="Olivier SANS"
              class="avatar avatar-xlg mb-3"
            >
            <h6 class="mb-0">Olivier SANS</h6>
            <a href="https://www.linkedin.com/in/olivier-sans/" class="nav-link">
              <svg class="icon" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <title>LinkedIn icon</title>
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                ></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutUs"
};
</script>

<style>
</style>